var Stickyfill = require('stickyfilljs');

var el = document.querySelectorAll('.l-item-content__side-fixed');

// you can optionally pass `document` and `window` for reuse in iframes
Stickyfill.add(el);